"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
const sizeInit = 32;
var _default = exports.default = _styledComponents.default.div.withConfig({
  componentId: "sc-1g111ss-0"
})(["width:", ";height:", ";line-height:", ";border-radius:", ";text-align:center;text-transform:uppercase;color:", ";background-color:", ";font-size:", ";;font-weight:500;cursor:", ";opacity:", ";&:hover,&[data-opem]{opacity:1;}"], _ref => {
  let {
    size = sizeInit
  } = _ref;
  return "".concat(size, "px");
}, _ref2 => {
  let {
    size = sizeInit
  } = _ref2;
  return "".concat(size, "px");
}, _ref3 => {
  let {
    size = sizeInit
  } = _ref3;
  return "".concat(size / 10, "rem");
}, _ref4 => {
  let {
    size = sizeInit
  } = _ref4;
  return "".concat(size, "px");
}, (0, _color.default)('gray-2'), (0, _color.default)('gray-3'), _ref5 => {
  let {
    size = sizeInit
  } = _ref5;
  return "".concat(size / 20, "rem");
}, _ref6 => {
  let {
    onClick
  } = _ref6;
  return onClick ? 'pointer' : 'default';
}, _ref7 => {
  let {
    open
  } = _ref7;
  return open ? 1 : 0.9;
});